<template>
  <BasicSidebar ref='sidebar'>
    {{ adminUsers }}
    {{ users }}
  </BasicSidebar>
</template>

<script>
import sidebar from '@core/mixins/sidebar'
import BasicSidebar from '@core/components/common/BasicSidebar'
import { mapState } from 'vuex'

export default {
  name: 'AddUserToGroup',
  components: { BasicSidebar },
  mixins: [sidebar],
  computed: {
    ...mapState('group', ['adminUsers', 'users'])
  }
}
</script>

<style scoped>

</style>
